export enum PropertyFiltersFields {
  ADDRESS = 'address',
  EMAIL = 'user_email',
  PHONE_NUMBER = 'user_phone_number',
  TYPE = 'property_type',
  ORDERS_SUM = 'total_orders_sum_gte',
  ESTABLISHED = 'established',
  OWNERS = 'user_name',
  PROGRESS = 'steps_completed',
  CURSOR = 'cursor',
  CREATED = 'created',
  VALUATION_PRICE = 'valuation_price_gte',
  SOLD_PRICE = 'sold_price_gte',
}

export type TPropertyFiltersValues = {
  [PropertyFiltersFields.EMAIL]?: string;
  [PropertyFiltersFields.PHONE_NUMBER]?: string;
  [PropertyFiltersFields.ADDRESS]?: string;
  [PropertyFiltersFields.TYPE]?: string[];
  [PropertyFiltersFields.PROGRESS]?: string[];
  [PropertyFiltersFields.ORDERS_SUM]?: string;
  [PropertyFiltersFields.OWNERS]?: string;
  [PropertyFiltersFields.ESTABLISHED]?: string;
  [PropertyFiltersFields.CURSOR]?: string;
  [PropertyFiltersFields.VALUATION_PRICE]?: string;
  [PropertyFiltersFields.SOLD_PRICE]?: string;
};
